import { AdminService } from 'src/app/services/admin.service';
import { AlertModel } from 'src/app/models/alert.model';
import { AlertService } from 'src/app/services/alert.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Icons } from 'src/app/models/icons.model';
import { map, startWith } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-admin-alert',
  standalone: false,
  templateUrl: './admin-alert.component.html',
  styleUrls: ['./admin-alert.component.scss'],
  providers: [NgOptimizedImage]
})
export class AdminAlertComponent implements OnInit, OnDestroy {
  // Event Handlers
  private adminLoadedEventHandler: Subscription;

  // Variables
  alertModel: AlertModel = new AlertModel();
  filter = new UntypedFormControl('');
  filteredAlerts: Observable<AlertModel[]>;
  icons = new Icons();

  constructor(public adminService: AdminService, private alertService: AlertService,) { }

  ngOnInit(): void {
    if (!this.adminService.isReady) {
      this.adminLoadedEventHandler = this.adminService.adminServiceLoadedEvent.subscribe(
        () => {
          this.initSearch();
        }
      );
    } else {
      this.initSearch();
    }
  }

  ngOnDestroy() {
    if (this.adminLoadedEventHandler)
      this.adminLoadedEventHandler.unsubscribe();
  }

  // Search
  private initSearch() {
    this.filteredAlerts = this.filter.valueChanges.pipe(
      startWith(''),
      map((text) => this.searchAlerts(text))
    );
  }

  clearSearch() {
    this.filter.setValue('');
  }

  private searchAlerts(text: string): AlertModel[] {
    return this.adminService.alerts?.filter((alert) => {
      const term = text.toLowerCase();
      return (
        alert.Name?.toLowerCase().includes(term) ||
        alert.SiteName?.includes(term)
      );
    });
  }

  /**
   * Enable or disable a specific alert
   * @param  {any} event - Status of Alert
   * @param  {number} alertId - The alert id
   * @returns void
   */
  private toggleAlert(event: any, alertId: number): void {
    // Update Alert Model
    this.alertModel.Id = alertId;
    this.alertModel.Enabled = event;

    // Update the Alert
    this.alertService
      .toggleAlert(this.alertModel)
      .catch((err) => console.error(err));
  }

  copyTriggerUrl(alertId: number) {
    var url = `https://valcoatweb/acs-api/acs/events/trigger?alertId=${alertId}`;
    navigator.clipboard.writeText(url).then(() => {
      console.log('URL copied to clipboard:', url);
    }).catch(err => {
      console.error('Failed to copy URL: ', err);
    });
  }
}
